import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CreateInitiative } from '@ui/initiatives';
import { InitiativesSummaryNotifications } from './notifications';
import { InitiativesTable } from './InitiativesTable';
import React from 'react';
import { useCurrentUser } from '@hooks';

import { SonarCard, ViewArea } from '@ui/general';

export const InitiativesSummaryIndex: React.FC = () => {
	const { isReadOnly } = useCurrentUser();

	return (
		<ViewArea id='initiatives-view'>
			<SonarCard
				extra={ !isReadOnly && <CreateInitiative
					noPadding
					source='menu' /> }
				noSpacingX
				title={ COPY_SPECIFIC.INITIATIVES }>
				<InitiativesTable id='initiatives-table' />
			</SonarCard>
			<InitiativesSummaryNotifications />
		</ViewArea>
	);
};
